export const webdavGetters = {
    webdavLoginUsername: state => state.webdavLoginUsername,
    webdavLoginPassword: state => state.webdavLoginPassword,
};
